import { Image, imageKit } from './Image';
import { ImageNG } from './ImageNG';
import { initCustomElement } from './customElementInit';

export { Image, ImageNG, initCustomElement, imageKit };
export * from './types';
